export default __webpack_public_path__ + "static/media/logoBlueBg.10e01178.svg";